var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.experience.start)+" ~ "+_vm._s(_vm.experience.end))]),_c('h3',[_vm._v(_vm._s(_vm.experience.job_title))]),_c('h3',[_c('a',{attrs:{"target":"_blank","href":_vm.experience.company_link}},[_vm._v(_vm._s(_vm.experience.company_name))])]),_c('p',[_vm._v(" "+_vm._s(_vm.experience.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }